// @ts-nocheck
import { NotificationsFollowedModel, UserNotificationInviteCollegueModel } from "@store/Framework/Types/ApiModels";
import {
    defaultContext,
    UserNotificationPreferencesContext,
    UserNotificationPreferencesContextModel,
} from "@store/Framework/Components/UserNotificationPreferencesContext/UserNotificationPreferencesContext";
import React, { FC, PropsWithChildren, useState } from "react";

const UserNotificationPreferencesContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [isLoading, setIsLoading] = useState<boolean>(defaultContext.isLoading);
    const [notificationsFollowed, setNotificationsFollowed] = useState<NotificationsFollowedModel | null>(
        defaultContext.notificationsFollowed,
    );
    const [customerSoldTo, setCustomerSoldTo] = useState<UserNotificationInviteCollegueModel | null>(
        defaultContext.customerSoldTo,
    );
    const [responseCode, setResponseCode] = useState<string>(defaultContext.responseCode);
    const [errorMessage, setErrorMessage] = useState<string | null>(defaultContext.errorMessage);
    const [updateSuccessful, setUpdateSuccessful] = useState<boolean>(false);
    const [updateErrorMessage, setUpdateErrorMessage] = useState<string | null | undefined>();

    const providerValue: UserNotificationPreferencesContextModel = {
        isLoading,
        notificationsFollowed,
        customerSoldTo,
        responseCode,
        errorMessage,
        updateSuccessful,
        updateErrorMessage,
        setIsLoading,
        setResponseCode,
        setErrorMessage,
        setNotificationsFollowed,
        setCustomerSoldTo,
        setUpdateSuccessful,
        setUpdateErrorMessage,
    };

    return (
        <UserNotificationPreferencesContext.Provider value={providerValue}>
            {children}
        </UserNotificationPreferencesContext.Provider>
    );
};

export default UserNotificationPreferencesContextProvider;
